import styled from "styled-components"

export default styled.div`
    background-position: ${({align}) => align ? align : 'center'};
    background-repeat: no-repeat;
    background-size: contain;
    margin: 40px;
    
    flex: ${({size}) => size ? 'auto' : '1'};
    
    width: ${({ size }) => {
      switch (size) {
        case 'xsmall':
          return '20%';
        case 'small':
          return '35%';
        case 'medium':
          return '50%';
        case 'big':
          return '80%';
        default:
          return '100%'
      }
    }};
    
    margin: ${({ size }) => {
      switch (size) {
        case 'xsmall':
        case 'small':
        case 'medium':
          return '10px';
        case 'big':
          return '20px';
        default:
          return '40px'
      }
    }};
    
    height: ${({ size }) => {
      switch (size) {
        case 'xsmall':
          return '20%';
        case 'small':
          return '35%';
        case 'medium':
          return '50%';
        case 'big':
          return '80%';
        default:
          return '100%'
      }
    }};
    background-image: url(${({src}) => src});
`